import { render, staticRenderFns } from "./DataImporting.vue?vue&type=template&id=39acd4e0&scoped=true"
import script from "./DataImporting.vue?vue&type=script&lang=ts"
export * from "./DataImporting.vue?vue&type=script&lang=ts"
import style0 from "./DataImporting.vue?vue&type=style&index=0&id=39acd4e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39acd4e0",
  null
  
)

export default component.exports